import theme1 from './theme1';

export default {theme1}